(function (window, $) {

	function handleClickSetLangCookie(e) {
		Cookies.set('lang', e.currentTarget.dataset.lang, { expires: 365 });
	}

	function handleClickHomepageScrollDown() {
		const navbarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--navbar-height'), 10);

		window.scroll({
			behavior: 'smooth',
			left: 0,
			top: document.querySelector('.homepage-boxes').offsetTop - navbarHeight,
		});
	}

	function handleClickEshopDetailDreamBoxButton() {
		$('.dreambox-alert').toast('show');
	}

	function handleClickEshopDetailDreamBoxButtonRemove() {
		$('.dreambox-alert-remove').toast('show');
	}

	function handleClickProfileFormSubmitButton() {
		$('.submit-alert').toast('show');
	}

	document.addEventListener('DOMContentLoaded', () => {

		// Přepínání jazyků
		const navItemLangEl = document.querySelector('.js-nav-item-lang');
		if (navItemLangEl) {
			navItemLangEl.addEventListener('click', handleClickSetLangCookie);
		}

		// Nascrollování níze na homepage
		const homepageScrollDownButton = document.querySelector('.js-homepage-scroll-down');
		if (homepageScrollDownButton) {
			homepageScrollDownButton.addEventListener('click', handleClickHomepageScrollDown);
		}

		// Přidáno položky do Dream boxu
		const dreamBoxButton = document.querySelector('.js-eshop-detail-dreambox-button');
		if (dreamBoxButton) {
			$('.dreambox-alert').toast({
				delay: 10000,
			});
			dreamBoxButton.addEventListener('click', handleClickEshopDetailDreamBoxButton);
		}

		// Odebrání položky do Dream boxu
		const dreamBoxButtonRemove = document.querySelector('.js-eshop-detail-dreambox-button-remove');
		if (dreamBoxButtonRemove) {
			$('.dreambox-alert-remove').toast({
				delay: 10000,
			});
			dreamBoxButtonRemove.addEventListener('click', handleClickEshopDetailDreamBoxButtonRemove);
		}

		// Uložení osobních údajů
		const profileFormSubmitButton = document.querySelector('.js-profile-form-submit-button');
		if (profileFormSubmitButton) {
			$('.submit-alert').toast({
				delay: 10000,
			});
			profileFormSubmitButton.addEventListener('click', handleClickProfileFormSubmitButton);
		}

		// Inicializace tooltipů
		$('[data-toggle="tooltip"]').tooltip();

	});
})(window, jQuery);